import { render } from "./BuildUpdateNotification.vue?vue&type=template&id=f36d4ef2&scoped=true"
import script from "./BuildUpdateNotification.vue?vue&type=script&lang=js"
export * from "./BuildUpdateNotification.vue?vue&type=script&lang=js"

import "./BuildUpdateNotification.vue?vue&type=style&index=0&id=f36d4ef2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36d4ef2"]])

export default __exports__